import { render, staticRenderFns } from "./BalanceTransDetails.vue?vue&type=template&id=699715a9&scoped=true"
import script from "./BalanceTransDetails.vue?vue&type=script&lang=js"
export * from "./BalanceTransDetails.vue?vue&type=script&lang=js"
import style0 from "./BalanceTransDetails.vue?vue&type=style&index=0&id=699715a9&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "699715a9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('699715a9')) {
      api.createRecord('699715a9', component.options)
    } else {
      api.reload('699715a9', component.options)
    }
    module.hot.accept("./BalanceTransDetails.vue?vue&type=template&id=699715a9&scoped=true", function () {
      api.rerender('699715a9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ezpay/data/components/Balance/BalanceTransDetails.vue"
export default component.exports